export const LABELS = {
  purposeOfLoan: "Purpose of Loan",
  loanTermMonths: "Loan term (months)",
  firstChargeMortgageValue: "Outstanding first charge mortgage value",
  loanAmount: "Loan amount",
  propertyPurchasePrice: "Property purchase price",
  estimatedPropertyValue: "Estimated current property value",
  firstChargeLender: "First charge lender",
  mortgageAgeYears: "First charge mortgage age (years)",
  mortgageAgeMonths: "First charge mortgage age (months)",
  remainingTermOfFirstChargeLoanYears:
    "Remaining term of first charge mortgage (years)",
  remainingTermOfFirstChargeLoanMonths:
    "Remaining term of first charge mortgage (months)",
  isInterestRateFixedForAnInitialPeriod:
    "Is the first charge mortgage interest rate fixed for an initial period?",
  remainingTermOfInitialInterestRatePeriodMonths:
    "Remaining term of initial fixed interest rate period of first charge mortgage (months)",
};
